<template>
  <div class="ticket-index">
    <van-nav-bar
      left-text="上下班"
      fixed
      placeholder
    />

    <section class="ticket-content">
      <van-tabs :value="active" @change="onChange">
        <van-tab title="待乘车">
          <div class="ticket-wrapper">
            <OrderCard />
            <div class="load-more">没有更多数据</div>
          </div>
<!--          <div class="empty-content">-->
<!--            <div class="empty-text">你还没有相关订单</div>-->
<!--            <van-button type="primary" plain class="verify-button">去验票</van-button>-->
<!--          </div>-->
        </van-tab>
        <van-tab title="待支付">
          <div class="empty-content">
            <div class="empty-text">你还没有相关订单</div>
            <van-button type="primary" plain class="verify-button">去验票</van-button>
          </div>
        </van-tab>
        <van-tab title="全部订单">
          <div class="empty-content">
            <div class="empty-text">你还没有相关订单</div>
            <van-button type="primary" plain class="verify-button">去验票</van-button>
          </div>
        </van-tab>
      </van-tabs>
    </section>
  </div>
</template>

<script>
import OrderCard from '@/components/order/OrderCard.vue';

export default {
  components: { OrderCard },
  name: 'index',
  data() {
    return {
      active: 1,
    };
  },
  methods: {
    onChange(index) {
      this.active = index;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-nav-bar__text {
  color: #fff;
}

::v-deep .van-tabs__line {
  background-color: #36bafb;
}

::v-deep .van-tab.van-tab--active {
  color: #36bafb;
}

.ticket-content {
  width: 100vw;
  overflow-x: hidden;
  height: calc(100vh - 45px - 55px);
}

.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 45px - 55px - 44px);
  .empty-text {
    color: #e6e7e9;
    margin-bottom: 10px;
  }
}
.ticket-wrapper {
  margin-top: 5px;
}
.verify-button {
  color: #36bafb;
  border-color: #36bafb;
  border-radius: 10px;
  height: 35px;
}

.load-more {
  font-size: 13px;
  color: #6f7170;
  text-align: center;
}
</style>
